import { ContentLoader, FlexGap, StackVertical } from '@ukpostbox/frontend-framework';
import React from 'react';

function ForwardingBatchLoader() {
	return (
		<>
			<div className='page-header'>
				<div className='container-narrow'>
					<div className='row'>
						<div className='col-xs-1'>
							<ContentLoader round childCount={1} />
						</div>
						<div className='col-xs-2'>
							<ContentLoader round childCount={1} />
						</div>
					</div>
				</div>
			</div>

			<div className='card p-md mb-xxl'>
				<div className='container-narrow'>
					<div className='row'>
						<div className='col-xs-12 col-md-4'>
							<ContentLoader round childCount={1} childHeight='4em' />
						</div>
						<div className='col-xs-12 col-md-4'>
							<ContentLoader round childCount={1} childHeight='4em' />
						</div>
						<div className='col-xs-12 col-md-4'>
							<ContentLoader round childCount={1} childHeight='4em' />
						</div>
					</div>
				</div>
			</div>

			<div className='column-adjuster pl-md pr-md'>
				<div className='container-narrow'>
					<div className='row'>
						<div className='col-xs-12'>
							<StackVertical gap={FlexGap.ExtraExtraLarge}>
								<ContentLoader round childCount={1} childHeight='12em' />
								<ContentLoader round childCount={1} childHeight='12em' />
								<ContentLoader round childCount={1} childHeight='12em' />
								<ContentLoader round childCount={1} childHeight='12em' />
								<ContentLoader round childCount={1} childHeight='12em' />
							</StackVertical>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export { ForwardingBatchLoader };
